import { FC, MouseEventHandler, useCallback } from 'react';
import { useQuery } from 'react-query';
import { PersonAPI } from '@frontend/api-person';
import { ContactPanelHeader } from '@frontend/contact-panel';
import { useAppScopeStore } from '@frontend/scope';
import { useContactPanelShallowStore } from '@frontend/shared';
import { SpinningLoader } from '@frontend/design-system';
import { containerStyle } from './task-patient-tooltip.styles';

interface TaskPatientTooltipContentProps {
  patientId: string;
  locationId?: string;
  closeTooltip?: () => void;
  onMouseEnter?: MouseEventHandler<any>;
  onMouseLeave?: MouseEventHandler<any>;
}

export const TaskPatientTooltipContent: FC<TaskPatientTooltipContentProps> = ({
  patientId,
  locationId,
  closeTooltip,
  ...rest
}) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { setPersonId } = useContactPanelShallowStore('setPersonId');
  const personLocationId = locationId ?? selectedLocationIds?.[0];

  const { data: person, isFetching } = useQuery({
    queryKey: [patientId, personLocationId],
    queryFn: () => PersonAPI.getPersonExtended(patientId, personLocationId),
    onError: () => closeTooltip?.(),
  });

  const onClick = useCallback(() => {
    setPersonId(patientId, true, personLocationId);
    closeTooltip?.();
  }, [setPersonId, patientId, personLocationId, closeTooltip]);

  if (isFetching) {
    return <SpinningLoader />;
  }

  if (person) {
    return (
      <div onClick={onClick} css={containerStyle} {...rest}>
        <ContactPanelHeader person={person} personLocationID={personLocationId} onClick={onClick} />
      </div>
    );
  }
  return null;
};
